import store from '@/store/index'
import {
    getLoginInfo
} from '@/utils/loginInfo'
import {
    getLocalConfig
} from '@/utils/session'

const { addVisitLog } = require('@/models/common.js')

const mutations = {
}

export const actions = {
    // 登录后统计逻辑
    visitLog () {
        if (!getLocalConfig('GOODSDETAIL')) return
        let link = getLocalConfig('GOODSDETAIL')
        let pathName = link.split('?')[0]
        let urlData = link.split('&')
        let page_code = ''
        let param_type = ''
        let topic_id = ''
        let activity_id = ''
        let visitType = ''
        let sstore_id = ''
        urlData.forEach((item) => {
            let temp = item.split('=')
            let key = temp[0]
            let val = temp[1]
            if (key === 'page_code') {
                page_code = val
            };
            if (key === 'topic_id') {
                topic_id = val
                param_type = key
            };
            if (key === 'activity_id') {
                activity_id = val
                param_type = key
            }
            if (key === 'visitType') {
                visitType = val
            }
            if (key === 'sstore_id') {
                sstore_id = val
            }
        })
        let arr = ['/moreSstoreGoodsDetail', '/goodsDetail']
        let pageCodeArr = [
            'mergeSpread', // 聚合推广
            'customDetail', // 商家推广-自定义多店
            'regularCustomDetail', // 商家推广-常规推广多店
            'marketingDetail', // 特价活动多店
            'specialActivity', // 特价活动单店
            'seckill', // 秒杀
        ]
        if ((topic_id || activity_id) && arr.indexOf(pathName) > -1 && pageCodeArr.indexOf(page_code) > -1) {
            const {
                user_id = ''
            } = getLoginInfo()
            store.dispatch('addVisitLog', {
                user_id: user_id ? Number(user_id) : 0, // 用户id (0 为未登录)
                channel: 2, // 访问渠道 (1 微养车 2 H5)
                visit_type: Number(visitType) === 2 ? 2 : 1, // 访问类型 (1普通进入 2分享链接 3扫二维码(预留))
                page_code,
                param_type: param_type,
                param_value: topic_id || activity_id,
                sstore_id
            })
        }
    },

    // 统计接口
    addVisitLog ({
        commit
    }, data) {
        addVisitLog(data)
    }
}
export const getters = {

}

export default {
    // state,
    mutations
}
